/**
 *
 * HeaderActions
 *
 */
import React from 'react';
import { ShellAvatar } from '../ShellAvatar';
import {
  DialogTrigger,
  ActionButton,
  Text,
  ProgressCircle
} from '@adobe/react-spectrum';
import Button from '@react/react-spectrum/Button';
import Search from '@spectrum-icons/workflow/Search';
import '../ShellHeader/ShellHeader.scss';
import './HeaderActions.scss';
import classNames from 'classnames';
import { UserProfilePopOver } from '../UserProfile/Loadable';
import {
  selectProfileError,
  selectProfileLoading,
  selectUserProfile
} from 'app/pages/Layout/slice/selectors';
import { useSelector } from 'react-redux';
import SearchBar from 'app/components/Fields/SearchField';

interface Props {
  feedback?: any;
  onSignOutClick?: any;
  customSearch?: any;
}

export const HeaderActions: Function = (props: Props) => {
  const userProfile = useSelector(selectUserProfile);
  // const profilePic = `https://s7d2.scene7.com/is/image/IMGDIR/${
  //   userProfile && userProfile.uid
  // }?$100x$`;
  const profilePic = `https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png`;
  const isLoading = useSelector(selectProfileLoading);
  const error = useSelector(selectProfileError);

  // const feedbackComponent = () => {
  //   return (
  //     <a
  //       data-testid="shell-header-provide-feedback-link"
  //       href="https://forms.office.com/pages/responsepage.aspx?id=Wht7-jR7h0OUrtLBeN7O4beptsewLNtFnTt9RuWeB7JUQjM2U0tUNlpCUU4wWEc5WTVaV085TUlEUy4u&route=shorturl"
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       style={{
  //         color: '#1473E6',
  //         textDecoration: 'none',
  //         fontSize: '14px',
  //         fontWeight: '500',
  //         marginRight: '16px',
  //         display: 'flex',
  //         alignItems: 'center'
  //       }}
  //     >
  //       Provide Feedback
  //     </a>
  //   );
  // };

  const userProfileComponent = () => {
    const { onSignOutClick } = props;

    // Extract user data with fallbacks
    const firstName = userProfile?.firstname || '';
    const lastName = userProfile?.lastname || '';
    const email = userProfile?.email || '';
    const displayName =
      firstName && lastName ? `${firstName} ${lastName}` : 'Loading...';

    return (
      <DialogTrigger type="popover" key="userProfile" hideArrow>
        <ActionButton isQuiet data-testid="header-actions-user-profile-button">
          <ShellAvatar src={profilePic} />
        </ActionButton>
        <>
          {isLoading && (
            <ProgressCircle
              aria-label="Loading…"
              isIndeterminate
              data-testid="header-actions-loading"
            />
          )}
          {error && (
            <Text data-testid="header-actions-error">
              Some issue while loading profile data.
            </Text>
          )}
          <UserProfilePopOver
            avatarUrl={profilePic}
            email={email}
            firstName={firstName}
            lastName={lastName}
            name={displayName}
            onSignOutClick={onSignOutClick}
          />
        </>
      </DialogTrigger>
    );
  };

  const customSearchComponent = () => {
    const { customSearch } = props;
    return <></>;
  };

  const renderDefaultActions = () => {
    const actions = [
      // feedbackComponent(),
      customSearchComponent(),
      userProfileComponent()
    ];
    return actions;
  };

  return renderDefaultActions();
};
